import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import "./QuestionnairesForm.css";
import TranslateWidget from "../Shared/TranslateWidget/TranslateWidget";
import EditForm from "./EditForm";
import { setTitle } from "../../redux/titleSlice";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";


export default function SendQuestionnairesForm() {


  const { eventID, QuestionnairesId, code } = useParams();
  const title = useSelector((state) => state.title.title);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const childStateRef = useRef();
  const editorRef = useRef(null);
  const [contractCount, setContractCount] = useState(0);
  const [showCustomURLInput, setShowCustomURLInput] = useState(true);

  const [shareduserdetail, setshareduserdetail] = useState([]);

  const [showpaging, setshowpaging] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);

  const [length, setlength] = useState(1);

  useEffect(() => {
    dispatch(setTitle('Untitled Questionnaires'));
  }, []);

  const handleRadioChange = (event) => {
    setShowCustomURLInput(event.target.value === "custom");
  };

  const [expanded, setExpanded] = useState(false);

  const toggleSidebar = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    // Create a <style> tag
    const styleTag = document.createElement("style");
    styleTag.innerHTML = "body { background-color: #f1f4f9 !important; }";

    // Append the <style> tag to the head
    document.head.appendChild(styleTag);

    // Cleanup: remove the style when the component unmounts
    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);



  const handleNextPage = () => {
    if (currentPage < length) {
      setCurrentPage(currentPage + 1);
    }
    if (currentPage == 0) {
      handleSubmit();

    }
  };

  // Handler for the previous button
  const handlePreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };







  const handleSubmit = async () => {


    const questionstate = childStateRef.current.getQuestion();
    const Title_2 = childStateRef.current.getTitle2();
    const placeholder_2 = childStateRef.current.getPlaceholder2();
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/sendquestionupdate/${QuestionnairesId}`,
        {
          questionstate: JSON.stringify(questionstate),
          code: code,
        });

      if (response.data.success) {





      }

    } catch (error) {
      console.error("Error fetching contracts:", error);
    }

  }


  useEffect(() => {
    const fetchQuestionnaires = async () => {
      try {
        const url = code
          ? `${process.env.REACT_APP_BACKEND_URL}/api/sharedQuestionnaires/${QuestionnairesId}/${code}`
          : `${process.env.REACT_APP_BACKEND_URL}/api/sharedQuestionnaires/${QuestionnairesId}`;
        const response = await axios.get(url);
        // setContractContent(response.data.pages[0].content);
        // setinvoicetitle(response.data.title);


        // setinvoiceitem(response.data.invoice_item);

        // setinvoicepayments(response.data.invoice_payment);



        dispatch(setTitle(response.data.sharedQuestionnaires.title));



        setshareduserdetail(response.data.user);


        //setContractCount(response.data.question__pages.length+1);

      } catch (error) {
        console.error('Error fetching contract:', error);
      }
    };
    fetchQuestionnaires();
  }, []);

  return (
    <>
      <div className="customer-view-translate-bar bg-light border-bottom">
        <div className="customer-view-translate-bar-inner">
          <TranslateWidget />
        </div>
      </div>
      <div className='container-fluid p-lg-0 py-lg-3 p-md-5 p-3 widthfix-container' style={currentPage == length + 1 ? { backgroundColor: '#e8eff7', display: 'block ruby', textAlign: 'center', height: '100vh' } : { display: 'block ruby', textAlign: 'center' }}>
        <div className='row g-lg-5 g-md-5 g-3 px-lg-5'>
          <div className='col-md-12 text-end mt-n1 mb-3'>

          </div>
          {/*begin: Main form area */}
          <div className='col-md-12 center8' style={currentPage == length ? { /*width: '750px',*/ borderRadius: '20px' } : {}} >
            <div className="gap2"></div>

            {!showpaging && (<>

              <div className="pagination-controls col-md-12 text-end">
                {currentPage > 0 ? (<>
                  {/* <button onClick={handlePreviousPage} disabled={currentPage === 0} className="Nxt">
        Previous
      </button> */}
                </>) : (<></>)}

                <span> Page {currentPage + 1} of {length + 1} </span>

                {currentPage < length ? (<>
                  <button onClick={handleNextPage} disabled={currentPage === length} className="Nxt">
                    Next
                  </button>
                </>) : (<></>)}
                <p style={{ height: '5px' }}>&nbsp;</p>


              </div>

            </>)}
            <div className='form_container tab-content ' style={currentPage == length ? { borderRadius: '20px', margin: '0px', padding: '0px', boxShadow: 'rgba(0, 0, 0, 0.2) 0px 4px 8px 0px, rgba(0, 0, 0, 0.19) 0px 6px 20px 0px' } : {
              margin: '0px', padding: '0px', textAlign: 'left'
            }}>


              {currentPage < length && (<>

                <div
                  className='tab-pane fade show active'
                  id='v-pills-home'
                  role='tabpanel'
                  aria-labelledby='v-pills-home-tab'
                  tabIndex='0'>
                  <EditForm ref={childStateRef} />
                </div>



              </>)}






              {currentPage == length && (<>

                <div className="py-5" style={{ width: '75%', margin: '0px auto', textAlign: 'center' }}>

                  <div className='logo' style={{ width: '50%', margin: '0px auto' }}>
                    <h4>
                      <img src={shareduserdetail.Secondary_Logo ? process.env.REACT_APP_BACKEND_URL + shareduserdetail.Secondary_Logo : null} alt='Secondary Logo Preview' className='mainimgpath img-fluid' style={{ maxWidth: '200px' }} />
                    </h4>
                  </div>

                  <div style={{ fontSize: '26px' }}><b>All done!</b></div>

                  <div style={{ textAlign: "centre", margin: '10px' }}>“Thank you for completing the questionnaire! Your responses have been successfully submitted and will be shared with the event organizer.”</div>
                  <div className="pb-3">
                    <span >“If you need to make any changes or have additional details to provide, please reach out directly to them.”</span>
                  </div>
                </div>

              </>)}
            </div>

            {!showpaging && (<>

              <div className="pagination-controls col-md-12 text-end mt-3">
                {currentPage > 0 ? (<>
                  {/*  <button onClick={handlePreviousPage} disabled={currentPage === 0} className="Nxt">
        Previous
      </button> */}
                </>) : (<></>)}

                <span> Page {currentPage + 1} of {length + 1} </span>

                {currentPage < length ? (<>
                  <button onClick={handleNextPage} disabled={currentPage === length} className="Nxt">
                    Next
                  </button>
                </>) : (<></>)}


              </div>

            </>)}






          </div>
          {/*end: Main form area */}
          {/*begin: Sidebar area */}
          <div className='col-lg-4 center4'>

            <span className='placeholder col-6'></span>

            <div className='row'>
              <div className='col-12'>
                <div className='right-side-area'>
                  <div
                    className='nav flex-column nav-pills me-3'
                    id='v-pills-tab'
                    role='tablist'
                    aria-orientation='vertical'>


                    {/* Current Page Begin: Invoice Box */}




                    {/* Current Page Begin: Invoice Box */}


                  </div>













                </div>
              </div>
            </div>





            {/* <div
              className={`side_bar_contract_form shadow  ${
                expanded ? "aside-menu--expanded" : ""
              }`}>
              <div className='sidebar_header'>
                {!expanded ? (
                  <button
                    type='button'
                    className='mt-3 ms-4 text-black hamburger_side'
                    onClick={toggleSidebar}>
                    <i className='fas fa-times'></i>
                  </button>
                ) : (
                  <button
                    type='button'
                    className='mt-3 ms-4 text-black hamburger_side hamburger_side_mobile'
                    onClick={toggleSidebar}>
                    <i className='fas fa-bars hamburger_side_icon'></i>
                  </button>
                )}
                <h5
                  className={`mb-2 ${
                    expanded ? "aside-menu--expanded-body-content" : ""
                  }`}>
                  Setting
                </h5>
              </div>
              <div
                className={`sidebar_content_body px-2 ${
                  expanded ? "aside-menu--expanded-body-content" : ""
                }`}>
                <div className='form_sidebar'>
                  <div className='sidebar_main'>
                    <div className='sidebar-content'>
                      <h5 className='mb-3'>
                        After Form Complication Redirect To
                      </h5>
                      <div className='form_group position-relative'>
                        <div className='form-check mb-2'>
                          <input
                            className='form-check-input'
                            type='radio'
                            name='redirectOption'
                            id='flexRadioDefault1'
                            value='default'
                            onChange={handleRadioChange}
                            defaultChecked
                          />
                          <div>
                            <label
                              className='form-check-label form-check-label_sidebar label_tooltip'
                              htmlFor='flexRadioDefault1'>
                              Default Thank You Message
                              <span className='ques_arrow'>
                                <i className='fa-solid fa-question'></i>
                              </span>
                            </label>
                            <div className='toolTipContent d-none'>
                              <span>
                                When your client submits a form, well show a
                                default Thank You message to confirm receipt
                              </span>
                              <div className='arrowForm'></div>
                            </div>
                          </div>
                        </div>
                        <div className='form-check'>
                          <input
                            className='form-check-input'
                            type='radio'
                            name='redirectOption'
                            id='flexRadioDefault2'
                            value='custom'
                            onChange={handleRadioChange}
                          />
                          <label
                            className='form-check-label form-check-label_sidebar'
                            htmlFor='flexRadioDefault2'>
                            Your Own Custom URL
                          </label>

                          {showCustomURLInput && (
                            <div className='link_input'>
                              <input
                                type='text'
                                placeholder='https://mywebsite.com/thanks'
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='sidebar-bottom'>
                      <h5 className='mb-3'>SPAM PROTECTION</h5>
                      <p>
                        PB Web App uses Google as your Contact Form Spam
                        Protection
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>*/}
          </div>
          {/*end: Sidebar area */}
        </div>
      </div>
    </>
  );
}
